import { RIVERGENERALSITUACTION } from '../actions/riverGeneralSituationAction'

import { reducerPackage } from "../../utils"

export const riverGeneralSituation = reducerPackage(RIVERGENERALSITUACTION)
